import TruckIcon from "../mixins/truck-icon";
import { KTimeAgo } from "kinnect-general";

export default {
	name: "KTrucksMapSidebarRow",

	inject: [ "storeModuleName" ],

	props: {
		expanded: Boolean,
		truck: Object
	},

	mixins: [ TruckIcon ],

	computed: {
		rootActiveMarker: {
			get() {
				return this.$store.state[this.storeModuleName].rootActiveMarker;
			},
			set( markerData ) {
				this.$store.dispatch( `${this.storeModuleName}/setRootActiveMarker`, markerData );
			}
		},

		selected() {
			return this.rootActiveMarker.type === "truck" && this.rootActiveMarker.id === this.truck.id;
		}
	},

	watch: {
		selected: {
			handler( val ) {
				if ( val ) {
					this.$emit( "update:expanded", val );
				}
			},
			immediate: true
		}
	},

	render() {
		return <tr
			class={{ "success white--text": this.selected }}
			key={this.truck.id}
			onClick={() => this.rootActiveMarker = {
				id: this.truck.id,
				type: "truck"
			}}
			style="cursor: pointer;"
		>
			<td><img src={this.iconContent}/></td>
			<td>{this.truck.activeTrip ? this.truck.activeTrip.driverNames : "--"}</td>
			<td>{this.truck.name}</td>
			<td>
				{this.truck.timestamp
					? <span><KTimeAgo startTime={this.truck.timestamp} levels={1}></KTimeAgo> ago</span>
					: "N/A"
				}
			</td>
		</tr>;
	}
};
